import { BaseResource } from './base';
import type {
  Invitation,
  CreateInvitationDto,
  AcceptInvitationDto,
  ValidateByCodeDto,
  ValidateByTokenDto,
} from '@gymspace/shared';
import { RequestOptions } from '../types';

export interface GetGymInvitationsParams {
  gymId: string;
}

export class InvitationsResource extends BaseResource {
  private basePath = 'invitations';

  async createInvitation(data: CreateInvitationDto, options?: RequestOptions): Promise<Invitation> {
    return this.client.post<Invitation>(this.basePath, data, options);
  }

  async getGymInvitations(
    params: GetGymInvitationsParams,
    options?: RequestOptions,
  ): Promise<Invitation[]> {
    return this.client.get<Invitation[]>(this.basePath, params, options);
  }

  async validateByCode(
    data: ValidateByCodeDto,
    options?: RequestOptions,
  ): Promise<{ email: string; gymName: string; roleName: string; token: string }> {
    return this.client.post(`${this.basePath}/validate-by-code`, data, options);
  }

  async validateByToken(
    data: ValidateByTokenDto,
    options?: RequestOptions,
  ): Promise<{ email: string; gymName: string; roleName: string; token: string }> {
    return this.client.post(`${this.basePath}/validate-by-token`, data, options);
  }

  async acceptInvitation(data: AcceptInvitationDto, options?: RequestOptions): Promise<void> {
    return this.client.post<void>(`${this.basePath}/accept`, data, options);
  }

  async cancelInvitation(id: string, options?: RequestOptions): Promise<void> {
    return this.client.put<void>(`${this.basePath}/${id}/cancel`, undefined, options);
  }

  async resendInvitation(id: string, options?: RequestOptions): Promise<void> {
    return this.client.post<void>(`${this.basePath}/${id}/resend`, undefined, options);
  }
}
